import { render, staticRenderFns } from "./DealsReportCotizaciones.vue?vue&type=template&id=08639cf1&"
import script from "./DealsReportCotizaciones.vue?vue&type=script&lang=js&"
export * from "./DealsReportCotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports